import { Injectable } from '@angular/core';
import { RestService } from '../rest/rest.service';
import { LocalStorageService } from '../storage/local-storage.service';
import { SessionStorageService } from '../storage/session-storage.service';

import { ModalTriggerConfiguration, TriggerType, TriggerLinkIdType } from './modal-notification.domain';

export interface TriggerInvocationRegistrationService {
  registerLaunch(trigger: ModalTriggerConfiguration): void;
  hasBeenLaunchedAlready(trigger: ModalTriggerConfiguration): boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserTriggerInvocationRegistrationService implements TriggerInvocationRegistrationService {

  constructor(private localStorageService: LocalStorageService,
              private restService: RestService) {
  }

  registerLaunch(trigger: ModalTriggerConfiguration): void {
    this.localStorageService.setItem(trigger.id, 'true');
    this.registerTriggerExecution(trigger);
  }

  hasBeenLaunchedAlready(trigger: ModalTriggerConfiguration): boolean {
    return this.localStorageService.getItem(trigger.id) === 'true';
  }

  private registerTriggerExecution(trigger: ModalTriggerConfiguration): void {
    const body = {
      notificationType: trigger.id
    };
    this.restService.getResource('notifications.update').put(body).subscribe();
  }
}

@Injectable({
  providedIn: 'root'
})
export class SessionTriggerInvocationRegistrationService implements TriggerInvocationRegistrationService {

  constructor(private sessionStorageService: SessionStorageService) {
  }

  registerLaunch(trigger: ModalTriggerConfiguration): void {
    this.sessionStorageService.setItem(trigger.id, 'true');
  }

  hasBeenLaunchedAlready(trigger: ModalTriggerConfiguration): boolean {
    return this.sessionStorageService.getItem(trigger.id) === 'true';
  }
}

@Injectable({
  providedIn: 'root'
})
export class ModalNotificationRegistryService {

  // if there are multiple triggers with triggerId 'any', only one should run in session.
  private anyTypeTriggerHasRunInSession: boolean = false;

  constructor(private userTriggerInvocationRegistrationService: UserTriggerInvocationRegistrationService,
              private sessionTriggerInvocationRegistrationService: SessionTriggerInvocationRegistrationService) {
  }

  hasBeenLaunchedAlready(trigger: ModalTriggerConfiguration): boolean {
    return (trigger.triggerLinkId ===  TriggerLinkIdType.ANY_URL && this.anyTypeTriggerHasRunInSession) ||
      this.checkIfContentHasBeenLaunched(trigger);
  }

  checkIfContentHasBeenLaunched(trigger: ModalTriggerConfiguration): boolean {
    return this.getStorageService(trigger).hasBeenLaunchedAlready(trigger);
  }

  registerLaunch(trigger: ModalTriggerConfiguration): void {
    this.anyTypeTriggerHasRunInSession = this.anyTypeTriggerHasRunInSession || trigger.triggerLinkId ===  TriggerLinkIdType.ANY_URL;
    this.getStorageService(trigger).registerLaunch(trigger);
  }

  private getStorageService(trigger: ModalTriggerConfiguration): TriggerInvocationRegistrationService {
    return trigger.persistence === TriggerType.PER_USER ?
      this.userTriggerInvocationRegistrationService
      : this.sessionTriggerInvocationRegistrationService;
  }
}
